
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Taxiservicenearme() {



    const cardData =
    {
        keyword: ' Taxi Service Near Me',
        heading: 'Prince Cabs: Taxi Service Near Me',
        headingDescription: 'Looking for a dependable Taxi Service Near Me? Prince Cabs offers reliable and affordable taxi services for local travel, airport transfers, corporate rides, family trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride every time. With professional chauffeurs, easy booking options, and on-time pickups, we make your travel completely hassle-free. Wherever you are in Pune, experience trusted and convenient rides with Prince Cabs’ nearby taxi service.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the seat of the Peshwas and remains Pune’s most iconic historical landmark. Though partially destroyed by fire, its grand gates, fortified walls, and sprawling gardens still stand strong. The evening light-and-sound show narrates Maratha history in an engaging way. Its stories of bravery, politics, and legends attract history buffs. Shaniwar Wada is a proud reminder of Pune’s glorious past. It is a must-visit for anyone exploring the city’s heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Built in 1892, Aga Khan Palace is a majestic monument associated with India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace houses a museum with artifacts, personal items, and photographs from Gandhi’s life. Its lush gardens and peaceful environment make it a favorite among visitors. The site combines architecture, history, and patriotism. It is a national treasure and UNESCO-recognized heritage landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is a historic hill fortress known for the Battle of Sinhagad in 1670. The fort’s ruins, bastions, and memorials tell tales of Maratha bravery. Trekkers enjoy the scenic climb, especially during monsoon when waterfalls and mist cover the hills. From the top, visitors enjoy panoramic views of the Sahyadri ranges. Traditional snacks like pithla-bhakri are sold at the summit. It is a blend of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous temple, attracting thousands of devotees daily. The idol of Lord Ganesha is beautifully adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the heart of Pune’s celebrations with grand decorations and cultural programs. The temple is also known for its charitable activities. Its central location makes it easily accessible to tourists. It is a spiritual landmark deeply woven into Pune’s identity."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of the highest points in Pune, offering panoramic views of the city. At the summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. The climb of over 100 steps is rewarded with serene vistas and a peaceful environment. The Peshwa Museum nearby showcases artifacts from the Maratha era. Sunrises and sunsets here are especially captivating. It is both a religious and recreational attraction for locals and tourists."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, dating back to the 8th century, is a rock-cut shrine dedicated to Lord Shiva. Carved out of a single basalt rock, it features intricate pillars, a sanctum with a Shiva linga, and unfinished structures. The temple is a fine example of Rashtrakuta architecture. Despite being in the city center, it offers a calm and spiritual environment. Visitors admire its historic and architectural significance. It is a hidden gem for history enthusiasts."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum displays over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, paintings, sculptures, and everyday objects from across India. Highlights include the Mastani Mahal, a reconstruction of Mastani’s palace. The museum reflects India’s diverse cultural heritage. It fascinates both children and adults with its rare collections. It is one of Pune’s best spots for art and history lovers."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a world-renowned spiritual retreat. Visitors from around the globe come here for meditation, yoga, and wellness programs. The ashram is set amidst lush gardens and modern facilities, creating a serene environment. It promotes holistic well-being and self-discovery. The community vibe and international presence add cosmopolitan charm. It is a unique destination blending spirituality with modernity."
  },
  {
    "title": "Phoenix Marketcity Pune",
    "description": "Phoenix Marketcity is Pune’s largest shopping and lifestyle mall, located in Viman Nagar. It houses hundreds of international and Indian brands, making it a shopper’s paradise. Entertainment options include multiplex cinemas, gaming zones, and live events. The mall also has a wide range of restaurants, bars, and cafés. Seasonal events like Christmas and Diwali celebrations make it lively. It is the perfect spot for shopping, dining, and leisure under one roof."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, situated about 20 km from Pune, is a popular picnic and weekend spot. The reservoir provides water to the city and offers scenic beauty with surrounding hills. Visitors enjoy boating, evening walks, and local street food like corn and bhajis. Monsoon enhances its charm with mist and greenery. Families flock here to relax away from city life. It is one of Pune’s most-loved natural retreats."
  },
  {
    "title": "Mulshi Lake and Dam",
    "description": "Mulshi Lake, located 40 km from Pune, is a tranquil destination surrounded by Sahyadri mountains. It is popular for camping, boating, and nature walks. During monsoon, waterfalls and lush landscapes make it enchanting. Eco-resorts around the lake offer a comfortable stay amidst nature. It is also a great photography and trekking spot. Mulshi is perfect for those seeking peace and adventure close to Pune."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, located on Senapati Bapat Road, is one of Pune’s oldest temples dedicated to Goddess Chaturshringi (Durga). Devotees climb over 100 steps to reach the hilltop shrine. The temple is especially vibrant during Navratri with grand decorations and celebrations. It attracts thousands of devotees from across Maharashtra. The panoramic views from the temple add to its charm. It remains a key religious and cultural landmark in Pune."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This memorial in Pune honors Indian soldiers who sacrificed their lives in various wars. It features a museum with artifacts, tanks, and war memorabilia. The evening flag retreat ceremony fills visitors with pride and patriotism. The memorial is surrounded by a peaceful park, making it a reflective spot. It is both educational and inspiring for families and students. It stands as a tribute to India’s armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread over 39 acres, is a botanical paradise maintained by the Agri-Horticultural Society. It is home to rare trees, plants, and beautiful flower nurseries. Families enjoy picnics under its shady trees. Annual flower shows attract garden enthusiasts. Its peaceful environment makes it a favorite among locals. It is an oasis of greenery within busy Pune city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi is Pune’s highest point, offering trekking trails, sunrise views, and fresh air. Popular among fitness enthusiasts, it has multiple routes for jogging and cycling. The hill is rich in biodiversity with birds and small wildlife. Locals love it for morning walks and yoga sessions. The hilltop provides panoramic views of the entire city. It is Pune’s green lung and a natural escape."
  }
],


"services": [
    {
        "name": "Local Taxi Service in Pune",
        "description": "Get fast and reliable local taxi service in Pune for daily commuting, office travel, and city tours. Our well-maintained vehicles and courteous drivers ensure timely pickups, safe rides, and a smooth travel experience throughout the city at affordable rates."
    },
    {
        "name": "Taxi Near Me",
        "description": "Find a taxi near your location in Pune instantly with our GPS-enabled booking platform. Whether it's an urgent ride or a scheduled pickup, we connect you with nearby taxis operated by trusted drivers to ensure quick and hassle-free travel."
    },
    {
        "name": "Cabs Near Me",
        "description": "Search and book cabs near you in Pune with just a few taps. Our wide network of vehicles ensures you’ll always find a comfortable cab nearby, ready to take you to your destination safely and on time, 24/7."
    },
    {
        "name": "Innova Cab Near Me",
        "description": "Locate and book an Innova cab near your area in Pune for group travel, family trips, or business travel. Spacious and reliable, our Innova cabs are driven by experienced chauffeurs and provide a comfortable travel experience."
    },
    {
        "name": "Innova Car Rental Near Me",
        "description": "Rent an Innova near your location in Pune for local or outstation travel. Ideal for families and small groups, our Innova rentals come with trained drivers, flexible rental durations, and competitive pricing."
    },
    {
        "name": "Innova for Rent Near Me",
        "description": "Book an Innova for rent near you in Pune for weekend getaways, airport transfers, or corporate events. Our vehicles are clean, comfortable, and available with experienced drivers for a smooth and secure journey."
    },
    {
        "name": "Innova Rental Near Me",
        "description": "Get access to the best Innova rental options near your location in Pune. Our rental service includes professional drivers, flexible booking hours, and affordable rates, perfect for both short and long-distance travel."
    },
    {
        "name": "Innova Taxi Near Me",
        "description": "Book an Innova taxi near your current location in Pune for safe and luxurious travel. With ample legroom and luggage space, our Innova taxis are perfect for family trips, outstation travel, or group transport."
    },
    {
        "name": "Book Taxi in Pune",
        "description": "Easily book a taxi in Pune for local city rides or outstation trips. Our user-friendly platform ensures quick booking, real-time tracking, and transparent pricing with a wide range of vehicles to choose from."
    },
    {
        "name": "Pune Taxi Service",
        "description": "Professional taxi services in Pune offering safe and convenient rides for all types of travelers. Whether it's a local trip, airport transfer, or long-distance journey, our drivers are punctual and our vehicles are well-maintained."
    },
    {
        "name": "Cheapest Cab Service in Pune",
        "description": "Book the most affordable cab service in Pune without compromising on quality or comfort. Ideal for budget-conscious travelers, our services offer clean vehicles, verified drivers, and economical pricing."
    },
    {
        "name": "Online Cab Booking Pune",
        "description": "Enjoy fast and secure online cab booking in Pune. Choose from multiple vehicle options, check fare estimates, and book instantly for local or outstation rides. Our digital platform makes booking simple and efficient."
    },
    {
        "name": "Best Cab Service Pune to Mumbai",
        "description": "Travel from Pune to Mumbai with the best cab service offering comfort, reliability, and affordable pricing. Our Pune to Mumbai cabs include professional drivers, AC vehicles, and flexible timing for one-way or round trips."
    },
    {
        "name": "24x7 Taxi Service Near Me",
        "description": "Get round-the-clock taxi services near your location in Pune. Whether it's late-night travel, early morning airport drops, or emergency trips, our 24x7 cab service ensures a safe and reliable ride anytime."
    },
    {
        "name": "Affordable Taxi Service Near Me",
        "description": "Find affordable taxi services near you in Pune that offer transparent pricing, clean vehicles, and dependable drivers. Perfect for daily travel, family outings, and budget outstation trips without any hidden costs."
    },
    {
        "name": "Reliable Taxi Service Near Me",
        "description": "Book reliable taxi services near your area in Pune for stress-free travel. We prioritize safety, punctuality, and comfort, with a fleet of well-maintained vehicles and verified drivers available at your convenience."
    },
    {
        "name": "Luxury Taxi Near Me",
        "description": "Travel in style with luxury taxis available near you in Pune. From high-end sedans to premium SUVs, enjoy top-notch service, plush interiors, and skilled drivers for special occasions or executive travel."
    },
    {
        "name": "Outstation Taxi Near Me",
        "description": "Looking for an outstation taxi near you in Pune? Our service connects you with experienced drivers and reliable cabs ready for long-distance journeys, weekend getaways, or pilgrimage trips at affordable rates."
    }
],
"tableData": [
    ["Local Taxi Service in Pune", "Taxi Near Me"],
    ["Cabs Near Me", "Innova Cab Near Me"],
    ["Innova Car Rental Near Me", "Innova for Rent Near Me"],
    ["Innova Rental Near Me", "Innova Taxi Near Me"],
    ["Book Taxi in Pune", "Pune Taxi Service"],
    ["Cheapest Cab Service in Pune", "Online Cab Booking Pune"],
    ["Best Cab Service Pune to Mumbai", "24x7 Taxi Service Near Me"],
    ["Affordable Taxi Service Near Me", "Reliable Taxi Service Near Me"],
    ["Luxury Taxi Near Me", "Outstation Taxi Near Me"]
],


"whychoose": [
    {
        "WhyChooseheading": "Instant & Reliable Taxi Service Near You in Pune",
        "WhyChoosedescription": "Looking for a taxi nearby? Prince Cabs offers quick and reliable taxi service near you, available across all major areas of Pune. Whether you’re at home, office, railway station, or a hotel, our cabs can reach you within minutes—ensuring you never have to wait long for a comfortable and safe ride."
    },
    {
        "WhyChooseheading": "Multiple Vehicle Options for Every Local Need",
        "WhyChoosedescription": "Our fleet includes a wide variety of cabs—from budget hatchbacks to premium sedans and SUVs—ready to serve you wherever you are in Pune. Whether you're heading to work, running errands, or picking someone up, we have the right vehicle available nearby to match your purpose and comfort preferences."
    },
    {
        "WhyChooseheading": "Professional Drivers With Area Knowledge",
        "WhyChoosedescription": "All our drivers are familiar with local roads, shortcuts, traffic trends, and landmarks in every part of Pune. You can expect courteous behavior, timely pickups, and safe driving whether you’re going just a few kilometers or traveling across the city."
    },
    {
        "WhyChooseheading": "Easy Booking via Call, Website, or WhatsApp",
        "WhyChoosedescription": "Prince Cabs makes it easy to book a taxi near you—just call us, visit our website, or drop a message on WhatsApp. We confirm your booking instantly and assign the nearest available cab to your location, with live tracking and driver contact details shared for your convenience."
    },
    {
        "WhyChooseheading": "Hygiene-Focused & Well-Maintained Cabs",
        "WhyChoosedescription": "All our vehicles are clean, air-conditioned, and sanitized before and after every trip. Regular maintenance ensures a smooth ride, while safety features like seat belts, GPS, and first-aid kits provide peace of mind for you and your family."
    },
    {
        "WhyChooseheading": "Transparent and Fair Pricing",
        "WhyChoosedescription": "Our local taxi service near you comes with affordable, fixed rates. No surge pricing, no hidden fees—just honest fares with multiple payment options including UPI, cards, net banking, or cash for maximum convenience."
    },
    {
        "WhyChooseheading": "24/7 Service Available Across Pune",
        "WhyChoosedescription": "Whether it’s early morning, late night, or peak office hours, our taxi service near you operates 24/7 across all parts of Pune. We’re just a call or tap away—ready to serve you whenever and wherever you need a reliable ride."
    }
]


























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide taxi service near me in Pune?',
        answer: 'Yes, Prince Cabs offers prompt taxi services across all areas of Pune. Whether you’re in the city center or the outskirts, we’re just a call or click away.',
    },
    {
        question: 'How quickly can I get a taxi from Prince Cabs near my location?',
        answer: 'We aim to provide taxis within 15–30 minutes of booking, depending on your location and traffic conditions. Advance bookings are also available.',
    },
    {
        question: 'What types of taxis are available near me?',
        answer: 'Prince Cabs offers hatchbacks, sedans, SUVs, and tempo travellers. You can choose a vehicle based on your travel needs and group size.',
    },
    {
        question: 'Is Prince Cabs available in all parts of Pune?',
        answer: 'Yes, we operate in all major areas including Hinjewadi, Kothrud, Baner, Viman Nagar, Wakad, Hadapsar, and more.',
    },
    {
        question: 'Can I book a taxi near me for local and outstation travel?',
        answer: 'Absolutely! Whether you need a short city ride or an outstation trip, you can book a taxi from the nearest location through our platform.',
    },
    {
        question: 'How can I find and book a Prince Cab near me?',
        answer: 'Simply search “Prince Cabs near me” or visit our website. You can also call us directly for fast bookings based on your current location.',
    },
    {
        question: 'Are the taxis safe and hygienic?',
        answer: 'Yes, all Prince Cabs are sanitized before every ride and driven by professional, background-verified drivers for your safety and peace of mind.',
    },
];

const testimonials = [
    {
        name: "Mr. Shreyas Deshpande",
        position: "Local Commuter",
        text: "I searched for a taxi near me and found Prince Cabs. They arrived in 15 minutes and the ride was very comfortable. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-nearme-1.png",
    },
    {
        name: "Ms. Kavita Sharma",
        position: "Working Professional",
        text: "Needed a quick ride to the railway station—Prince Cabs showed up fast and the service was excellent. Definitely the best taxi service near me in Pune.",
        image: "/img/testimonial/testimonial-thumb-nearme-2.png",
    },
];


































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Taxi Service Near Me",
  "image": "https://princecab.com/assets/images/taxi-service-near-me.jpg",
  "description": "Find reliable and affordable taxi service near you in Pune with Prince Cabs. Offering Innova, Dzire, and luxury cabs with 24x7 online booking and prompt service.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7000"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "0",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/taxi-service-near-me"
  }
};




    return (
        <div>
<Helmet>
  <title>Taxi Service Near Me | Reliable & Affordable Taxi | Prince Cabs</title>
  <meta
    name="description"
    content="Prince Cabs offers the best taxi service near you in Pune with affordable rates, reliable drivers, and 24x7 online booking. Choose from Innova, Dzire, and luxury cabs."
  />
  <meta
    name="keywords"
    content="Local taxi service in Pune, Taxi Near Me, Cabs Near Me, Innova Cab Near Me, Innova Car Rental Near Me, Innova for Rent Near Me, Innova Rental Near Me, Innova Taxi Near Me, Book Taxi in Pune, Pune Taxi Service, Cheapest Cab Service in Pune, Online Cab Booking Pune, Best Cab Service Pune to Mumbai, 24x7 Taxi Service Near Me, Affordable Taxi Service Near Me, Reliable Taxi Service Near Me, Luxury Taxi Near Me, Outstation Taxi Near Me"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/25.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Taxiservicenearme;